import React from 'react'
import MentorProfile from '../Profiles'


function Profiles(){
    return  <MentorProfile />
       
}

export default Profiles;